import React from "react"
import Date from "@bufox/standard-date"
import styled from "styled-components"

const ThemePostDate = styled(Date)`
  .date-modified {
    display: none;
  }
`

export default ThemePostDate
